import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import {
  Tooltip,
  Autocomplete,
  TextField,
  CircularProgress,
  Radio,
  RadioGroup,
  FormControlLabel,
  IconButton,
  FormHelperText,
} from "@mui/material";
import { callAPI } from "../../../../../axios";
import BasicModal from "../../../../core/BaseComponents/Modal";
import ClosedIcon from "@mui/icons-material/Close";
import { FaHotel } from "react-icons/fa";
import { MdEmail, MdLocationPin, MdCall } from "react-icons/md";
import {
  ScrollToTop,
  getChainIdLS,
  isValidRole,
} from "../../../../../utils/utils";
import { useSelector } from "react-redux";

function ConfigurationNewHotel() {
  let userRoleCode = JSON.parse(localStorage.getItem("userDetails"))?.roles[0]
    ?.roleCode;
  const [roomTypesMaster, setRoomTypesMaster] = useState([]);
  const [editHotel, setEditHotel] = useState(false);
  const [editHotelUpdate, setEditHotelUpdate] = useState(true);
  const [createHotelSuccessMsg, setCreateHotelSuccessMsg] = useState("");
  const [loader, setLoader] = useState(false);
  const [originalCdsns, setOriginalCdsns] = useState([]);
  const [showHintCdsns, setShowHintCdsns] = useState(false);
  const [showHintRoomType, setShowHintRoomType] = useState(false);
  const [viewType, setViewType] = useState("custom");
  const [viewTypeOnChange, setViewTypeOnChange] = useState(false);
  const [editApkProvider, setEditApkProvider] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    control,
    setValue,
    watch,
    trigger,
    clearErrors,
  } = useForm({
    mode: "onChange",
    defaultValues: {
      autoMode: false,
      priority: "MEDIUM",
    },
  });

  const { chainId } = useSelector((state) => state.chainIdReducer);
  console.log(chainId);

  let validPermissionClassName = isValidRole("HOTEL_CONFIGURATION_MODIFY")
    ? ""
    : "btn-disable-permission";

  const [roomTypeDisabled, setRoomTypeDisabled] = useState(false);

  const [appNameMasterList, setAppNameMasterList] = useState([]);

  useEffect(() => {
    clearErrors("roomTypes");
    if (viewType === "hotelApp") {
      setValue("roomTypes", []);
      setRoomTypeDisabled(true);
    } else {
      setRoomTypeDisabled(false);
    }
  }, [viewType]);

  const onSubmit = (data) => {
    setEditApkProvider(false);
    const method = "PUT";
    const url = `/hotel?sid=${chainId?.selectedChainId}`;

    const payload = { ...data, active: true, viewType: viewType };
    if (userRoleCode === "ROLE_SUPER_ADMIN") {
      delete payload.appName;
      delete payload.hotelChainId;
    }
    if (!data.autoMode) {
      delete payload.priority;
    }
    setLoader(true);
    callAPI(url, method, payload, { chainId: getChainIdLS() })
      .then(function (response) {
        setCreateHotelSuccessMsg(response?.message);
        setViewTypeOnChange(false);
        setLoader(false);
        // setEditHotelUpdate(true);
      })
      .catch(function (error) {
        console.warn(error.response?.data?.errorMessage);
        setLoader(false);
      });
  };

  useEffect(() => {
    setEditHotel(true);
  }, [chainId]);

  useEffect(() => {
    callAPI("/master/room-list", "GET")
      .then((res) => {
        setRoomTypesMaster(res?.roomType);
      })
      .catch((err) => {
        console.warn(err.message);
      });
    callAPI("/master/apk/apps", "GET")
      .then((res) => {
        const arrayResponse = res?.map((item) => item.appName);
        setAppNameMasterList(arrayResponse);
      })
      .catch((err) => {
        console.warn(err.message);
      });
  }, []);

  useEffect(() => {
    if (editHotel) {
      getHotelListSidHandler();
      setEditHotel(false);
    }
    ScrollToTop();
  }, [editHotel, chainId]);

  const getHotelListSidHandler = () => {
    setLoader(true);
    console.log(chainId?.selectedChainId);
    callAPI(`/hotel?sid=${chainId?.selectedChainId}`, "GET")
      .then(function (response) {
        setViewTypeOnChange(false);
        const payload = {
          hotelName: response?.hotelName,
          email: response?.email,
          contactNo: response?.contactNo,
          address: response?.address,
          zipCode: response?.zipCode,
          roomTypes: response.roomType,
          appName: response?.appName,
          latitude: response?.latitude,
          longitude: response?.longitude,
          cdsns: response.cdsns,
          autoMode: response.autoMode,
          priority: response.priority ? response.priority : "MEDIUM",
          enterpriseChainId: response?.entepriseChainId
            ? parseInt(response.entepriseChainId)
            : "",
        };
        setViewType(response?.viewType);
        setOriginalCdsns(response.cdsns);
        reset(payload);
        setLoader(false);
      })
      .catch(function (error) {
        console.warn(error.response?.data?.errorMessage);
        setLoader(false);
      });
  };

  const resetLayoutHandler = () => {
    reset();
    setEditApkProvider(false);
  };

  useEffect(() => {
    setEditHotel(true);
  }, []);

  return (
    <div className="row config-hotel">
      <div className="col-12 left-column">
        {loader && (
          <div style={{ zIndex: "99999" }} className="circular-progress">
            <CircularProgress />
          </div>
        )}
        <form
          autoComplete="off"
          onSubmit={handleSubmit(onSubmit)}
          className="hotel-list-form"
        >
          <div className="row">
            <div className="left-column-header">
              <p>
                {editHotelUpdate
                  ? "Edit Hotel Details"
                  : "Configuration New Hotel"}
              </p>
            </div>
            <div className="form-group-hotel col-6">
              <div
                className={`floating-label ${
                  userRoleCode !== "ROLE_SUPER_ADMIN" ? "disable-field" : ""
                }`}
              >
                <FaHotel className="new-hotel-icons" />
                <input
                  id="hotelName"
                  maxLength={35}
                  disabled={userRoleCode !== "ROLE_SUPER_ADMIN"}
                  placeholder=""
                  {...register("hotelName", {
                    required: "Please Enter Hotel Name",
                    pattern: {
                      value: /^[a-zA-Z0-9]+(?: [a-zA-Z0-9]+)*$/,
                      message:
                        "Only alphanumeric characters and single spaces between words are allowed",
                    },
                  })}
                />
                <label htmlFor="address">Enter Hotel Name</label>
              </div>
              {errors.hotelName && (
                <small className="required">{errors.hotelName.message}</small>
              )}
            </div>
            <Tooltip
              title={`${
                roomTypeDisabled
                  ? "Room Type not applicable for third party hotel apps"
                  : ""
              }`}
              arrow
            >
              <div className="form-group-hotel col-6">
                <div
                  className={`floating-select-label ${
                    roomTypeDisabled ? "btn-disable-permission" : ""
                  }`}
                >
                  <Controller
                    name="roomTypes"
                    control={control}
                    rules={{
                      validate: (value) => {
                        if (viewType === "hotelApp") return true; // No validation
                        return (
                          (Array.isArray(value) && value.length > 0) ||
                          "Please Select Room Type"
                        );
                      },
                    }}
                    render={({ field }) => (
                      <Autocomplete
                        {...field}
                        className={`multiselectlist ${
                          field.value && field?.value?.length > 0
                            ? "Mui-focused"
                            : ""
                        }`}
                        limitTags={2}
                        disablePortal
                        multiple
                        // disabled={userRoleCode !== "ROLE_SUPER_ADMIN"}
                        freeSolo
                        options={roomTypesMaster}
                        getOptionLabel={(option) => option.toString()}
                        onChange={(_, newValue) => {
                          field.onChange(newValue);
                        }}
                        value={field.value || []}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder=""
                            variant="outlined"
                            label="Select Room Type"
                            onFocus={() => setShowHintRoomType(true)}
                            onBlur={() => setShowHintRoomType(false)}
                            InputLabelProps={{
                              shrink: false,
                            }}
                          />
                        )}
                      />
                    )}
                  />
                  {errors.roomTypes && (
                    <p className="required text-start">
                      {errors.roomTypes.message}
                    </p>
                  )}
                  {showHintRoomType && (
                    <p className="hint-text">
                      Please press enter after each manually entered room type
                      to save
                    </p>
                  )}
                </div>
              </div>
            </Tooltip>
            <div className="form-group-hotel col-6">
              <div
                className={`floating-label ${
                  userRoleCode !== "ROLE_SUPER_ADMIN" ? "disable-field" : ""
                }`}
              >
                <MdEmail className="new-hotel-icons" />
                <input
                  id="email"
                  placeholder=""
                  maxLength={60}
                  disabled={userRoleCode !== "ROLE_SUPER_ADMIN"}
                  {...register("email", {
                    required: "Please Enter Your Email",
                    pattern: {
                      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                      message: "Enter Email in Correct format",
                    },
                  })}
                />
                <label htmlFor="address">Enter Email</label>
              </div>
              {errors.email && (
                <small className="required">{errors.email.message}</small>
              )}
            </div>
            <div className="form-group-hotel col-6">
              <div
                className={`floating-label ${
                  userRoleCode !== "ROLE_SUPER_ADMIN" ? "disable-field" : ""
                }`}
              >
                <MdCall className="new-hotel-icons" />
                <input
                  id="contactNo"
                  placeholder=""
                  maxLength={12}
                  minLength={10}
                  disabled={userRoleCode !== "ROLE_SUPER_ADMIN"}
                  {...register("contactNo", {
                    required: "Enter Contact Number",
                    pattern: {
                      value: /^[0-9]+$/,
                      message: "Invalid Contact number",
                    },
                  })}
                />
                <label htmlFor="address">Enter Contact Number</label>
              </div>
              {errors.contactNo && (
                <small className="required">{errors.contactNo.message}</small>
              )}
            </div>

            <div className="form-group-hotel col-3">
              <div
                className={`floating-label ${
                  userRoleCode !== "ROLE_SUPER_ADMIN" ? "disable-field" : ""
                }`}
              >
                <MdLocationPin className="new-hotel-icons" />
                <input
                  id="address"
                  disabled={userRoleCode !== "ROLE_SUPER_ADMIN"}
                  placeholder=""
                  // maxLength={32}
                  {...register("address", {
                    required: "Please Enter City Name",
                    pattern: {
                      value: /^[a-zA-Z\s]*$/,
                      message: "Enter Alphabets only",
                    },
                    maxLength: {
                      value: 32,
                      message: "Maximum length is 32 characters",
                    },
                  })}
                />
                <label htmlFor="address">Enter City Name</label>
              </div>
              {errors.address && (
                <small className="required">{errors.address.message}</small>
              )}
            </div>

            <div className="form-group-hotel col-3">
              <div
                className={`floating-label ${
                  userRoleCode !== "ROLE_SUPER_ADMIN" ? "disable-field" : ""
                }`}
              >
                <MdLocationPin className="new-hotel-icons" />
                <input
                  id="zipCode"
                  disabled={userRoleCode !== "ROLE_SUPER_ADMIN"}
                  placeholder=""
                  // maxLength={32}
                  {...register("zipCode", {
                    required: "Please Enter Zipcode",
                    pattern: {
                      value: /^[0-9\s]*$/,
                      message: "Enter Digits only",
                    },
                    maxLength: {
                      value: 6,
                      message: "Maximum length is 6 digits",
                    },
                    minLength: {
                      value: 5,
                      message: "Minimum length is 5 digits",
                    },
                  })}
                />
                <label htmlFor="address">Enter Zipcode</label>
              </div>
              {errors.zipCode && (
                <small className="required">{errors.zipCode.message}</small>
              )}
            </div>

            <div className="form-group-hotel col-6">
              <div className="row">
                <div className="col-6">
                  <div
                    className={`floating-label ${
                      userRoleCode !== "ROLE_SUPER_ADMIN" ? "disable-field" : ""
                    }`}
                  >
                    <MdLocationPin className="new-hotel-icons" />
                    <input
                      id="latitude"
                      disabled={userRoleCode !== "ROLE_SUPER_ADMIN"}
                      placeholder=""
                      {...register("latitude", {
                        required: "Please Enter Latitude",
                        pattern: {
                          value: /^-?[0-9]+(\.[0-9]*)?$/,
                          message: "Only numbers and dots are allowed",
                        },
                      })}
                    />
                    <label htmlFor="latitude">Enter Latitude</label>
                  </div>
                  {errors.latitude && (
                    <small className="required">
                      {errors.latitude.message}
                    </small>
                  )}
                </div>
                <div className="col-6">
                  <div
                    className={`floating-label ${
                      userRoleCode !== "ROLE_SUPER_ADMIN" ? "disable-field" : ""
                    }`}
                  >
                    <MdLocationPin className="new-hotel-icons" />
                    <input
                      id="longitude"
                      disabled={userRoleCode !== "ROLE_SUPER_ADMIN"}
                      placeholder=""
                      {...register("longitude", {
                        required: "Please Enter Longitude",
                        pattern: {
                          value: /^-?[0-9]+(\.[0-9]*)?$/,
                          message: "Only numbers and dots are allowed",
                        },
                      })}
                    />
                    <label htmlFor="longitude">Enter Longitude</label>
                  </div>
                  {errors.longitude && (
                    <small className="required">
                      {errors.longitude.message}
                    </small>
                  )}
                </div>
              </div>
            </div>
            {editHotelUpdate && (
              <div className="form-group-hotel col-6">
                {/* <button disabled={true} type="button" className="clear-btn me-2 btn-disable" >Fetch Cdsn's From Chain Id</button> */}
                {/* <UploadCDSNs handleDataFromChild={handleDataFromChild} /> */}
              </div>
            )}
            <div className="col-6 align-self-center form-group-hotel">
              <RadioGroup
                row
                name="viewType"
                value={viewType}
                onChange={(e) => {
                  setViewType(e.target.value);
                  setViewTypeOnChange((prev) => !prev);
                }}
                className="h-auto main-events mt-0 mb-1"
              >
                <FormControlLabel
                  value="custom"
                  control={<Radio />}
                  label="Tata Play Hotel Solution"
                  disabled={userRoleCode !== "ROLE_SUPER_ADMIN"}
                />
                <FormControlLabel
                  value="hotelApp"
                  control={<Radio />}
                  label="Third Party Hotel Apps"
                  disabled={userRoleCode !== "ROLE_SUPER_ADMIN"}
                />
              </RadioGroup>
              {editHotelUpdate && viewTypeOnChange && (
                <FormHelperText className="required-error">
                  Changing Hotel Type will impact Room Configurations / APK
                  Configurations
                </FormHelperText>
              )}
            </div>
            {editHotelUpdate && (
              <div className="form-group-hotel col-6">
                <div className="floating-select-label-color">
                  <Controller
                    name="cdsns"
                    control={control}
                    rules={{
                      validate: (value) => {
                        // Ensure value is an array
                        if (!Array.isArray(value)) {
                          return "Invalid CDSN data";
                        }

                        // Check if required (for edit mode)
                        if (editHotelUpdate) {
                          if (originalCdsns.length && !value.length) {
                            return "Please Enter CDSNs";
                          }
                        }

                        // Validate each CDSN
                        for (let i = 0; i < value.length; i++) {
                          const item = value[i];

                          // Convert to string if it's not already
                          const itemStr =
                            typeof item === "string" ? item : String(item);

                          // Remove any whitespace
                          const cleanItem = itemStr.trim();

                          // Skip empty values
                          if (!cleanItem) {
                            return `CDSN at position ${i + 1} is empty`;
                          }

                          // Check if it contains only numbers
                          if (!/^\d+$/.test(cleanItem)) {
                            return `CDSN "${cleanItem}" must contain only numbers`;
                          }

                          // Check exact length of 10
                          if (cleanItem.length !== 10) {
                            return `CDSN "${cleanItem}" must be exactly 10 digits (current: ${cleanItem.length})`;
                          }
                        }

                        return true;
                      },
                    }}
                    render={({ field }) => (
                      <Autocomplete
                        {...field}
                        className={`multiselectlist ${
                          field.value && field?.value?.length > 0
                            ? "Mui-focused"
                            : ""
                        }`}
                        limitTags={2}
                        disabled
                        disablePortal={false}
                        multiple
                        freeSolo
                        options={watch("cdsns") || []}
                        // Ensure consistent string handling
                        getOptionLabel={(option) => {
                          return typeof option === "string"
                            ? option
                            : String(option);
                        }}
                        // Proper filtering for search
                        filterOptions={(options, { inputValue }) => {
                          if (!inputValue) return options;
                          return options.filter((option) => {
                            const optionStr =
                              typeof option === "string"
                                ? option
                                : String(option);
                            return optionStr.includes(inputValue);
                          });
                        }}
                        // Handle input changes for search
                        onInputChange={(event, newInputValue, reason) => {
                          if (reason === "input") {
                            // Optional: Add search logic here
                            console.log("Searching for:", newInputValue);
                          }
                        }}
                        onChange={(_, newValue, reason, details) => {
                          if (reason === "clear") {
                            // setPendingClear(() => () => field.onChange([]));
                            // setCancelPopupClearHotel(true);
                            return;
                          }

                          // Handle the new value properly
                          let processedValue = [];

                          if (Array.isArray(newValue)) {
                            processedValue = newValue
                              .map((item) => {
                                // Convert to string and trim
                                const str =
                                  typeof item === "string"
                                    ? item.trim()
                                    : String(item).trim();
                                return str;
                              })
                              .filter((item) => item !== ""); // Remove empty strings
                          }

                          // Update the field value
                          field.onChange(processedValue);

                          // Trigger validation immediately
                          setTimeout(() => {
                            trigger("cdsns");
                          }, 0);
                        }}
                        value={field.value || []} // Ensure always an array
                        renderOption={(props, option) => (
                          <li
                            {...props}
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            {typeof option === "string"
                              ? option
                              : String(option)}
                            <IconButton
                              edge="end"
                              aria-label="remove"
                              style={{ marginLeft: "auto" }}
                              onClick={(e) => {
                                e.stopPropagation();
                                const currentValues = field.value || [];
                                const newValues = currentValues.filter(
                                  (item) => {
                                    const itemStr =
                                      typeof item === "string"
                                        ? item
                                        : String(item);
                                    const optionStr =
                                      typeof option === "string"
                                        ? option
                                        : String(option);
                                    return itemStr !== optionStr;
                                  }
                                );
                                field.onChange(newValues);
                                // Trigger validation after removal
                                setTimeout(() => {
                                  trigger("cdsns");
                                }, 0);
                              }}
                            >
                              <ClosedIcon />
                            </IconButton>
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Type to search or add CDSN..."
                            variant="outlined"
                            label="Select CDSN's"
                            onFocus={() => setShowHintCdsns(true)}
                            onBlur={(e) => {
                              setShowHintCdsns(false);

                              // Handle manual entry when user types and blurs
                              const inputValue = e.target.value?.trim();
                              if (
                                inputValue &&
                                !field.value?.includes(inputValue)
                              ) {
                                const newValues = [
                                  ...(field.value || []),
                                  inputValue,
                                ];
                                field.onChange(newValues);
                                // Clear the input
                                e.target.value = "";
                                // Trigger validation
                                setTimeout(() => {
                                  trigger("cdsns");
                                }, 0);
                              }
                            }}
                            onKeyDown={(e) => {
                              // Handle Enter key for adding new CDSN
                              if (e.key === "Enter") {
                                e.preventDefault();
                                const inputValue = e.target.value?.trim();
                                if (
                                  inputValue &&
                                  !field.value?.includes(inputValue)
                                ) {
                                  const newValues = [
                                    ...(field.value || []),
                                    inputValue,
                                  ];
                                  field.onChange(newValues);
                                  // Clear the input
                                  e.target.value = "";
                                  // Trigger validation
                                  setTimeout(() => {
                                    trigger("cdsns");
                                  }, 0);
                                }
                              }
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        )}
                      />
                    )}
                  />
                  {errors.cdsns && (
                    <p className="required text-start">
                      {errors.cdsns.message}
                    </p>
                  )}
                  {showHintCdsns && (
                    <p className="hint-text">
                      Type to search existing CDSNs or press Enter to add new
                      CDSN (must be 10 digits)
                    </p>
                  )}
                </div>
              </div>
            )}
            {userRoleCode !== "ROLE_SUPER_ADMIN" && viewType === "hotelApp" && (
              <div className="form-group-hotel col-6">
                <div className="floating-select-label">
                  <Controller
                    name="appName"
                    control={control}
                    rules={{
                      validate: (value) =>
                        (value !== undefined &&
                          value !== null &&
                          value !== "") ||
                        "Please Select APK Provider",
                    }}
                    render={({ field }) => (
                      <Autocomplete
                        {...field}
                        className={`multiselectlist ${
                          field.value && field?.value?.length > 0
                            ? "Mui-focused"
                            : ""
                        }`}
                        disablePortal
                        freeSolo
                        options={appNameMasterList}
                        getOptionLabel={(option) => option.toString()}
                        onChange={(_, newValue) => {
                          field.onChange(newValue);
                          setEditApkProvider(true);
                        }}
                        value={field.value || []}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder=""
                            variant="outlined"
                            label="Select APK Provider"
                            InputLabelProps={{
                              shrink: false,
                            }}
                          />
                        )}
                      />
                    )}
                  />
                  {errors.appName && (
                    <p className="required text-start">
                      {errors.appName.message}
                    </p>
                  )}
                </div>
                {editHotelUpdate && editApkProvider && (
                  <FormHelperText className="required-error">
                    Changing APK Provider Name will delete all existing APK
                    Configurations
                  </FormHelperText>
                )}
              </div>
            )}
            <div className="col-12 form-group-hotel text-end">
              {/* <button type="button" className="clear-btn me-2" onClick={cancelHotelHandler}>{editHotelUpdate ? "Cancel" : "Clear All"}</button> */}
              {editHotelUpdate && (
                <>
                  <button
                    type="button"
                    className="clear-btn me-2"
                    onClick={resetLayoutHandler}
                  >
                    Reset
                  </button>
                </>
              )}
              <button
                type="submit"
                className={`create-btn ${validPermissionClassName}`}
              >
                {editHotelUpdate ? "Update" : "Create"}
              </button>
            </div>
          </div>
        </form>
      </div>

      <BasicModal
        popupOpen={createHotelSuccessMsg !== ""}
        logo={"/Images/approve-qc.png"}
        bodyMessage={<p className="mt-2">{createHotelSuccessMsg}</p>}
        footer={{
          secondaryButton: {
            buttonName: "OK",
            action: () => {
              setCreateHotelSuccessMsg("");
              setEditHotelUpdate(true);
            },
            buttonPrimaryCustomCss: "cancel-btn_new",
          },
        }}
      />
    </div>
  );
}

export default ConfigurationNewHotel;
